import ufeApi from 'services/api/ufeApi';
import urlUtils from 'utils/Url';
import headerUtils from 'utils/Headers';
import shoppingListUtils from 'utils/ShoppingList';

const { userXTimestampHeader } = headerUtils;
// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Shopping+List

const _makeMultipleRequests = function (requestParamsList) {
    return Promise.all(requestParamsList.map(requestParams => ufeApi.makeRequest(requestParams.url, requestParams.options))).then(values => {
        let promise;

        const errors = values.filter(data => data.errorCode);

        if (errors.length) {
            promise = Promise.reject(errors);
        } else {
            promise = Promise.resolve(values);
        }

        return promise;
    });
};

function addItemsToShoppingList(params, isSLSABTestEnabled = false) {
    return _makeMultipleRequests(
        params.map(data => {
            const options = {
                skuId: data.skuId,
                source: data.loveSource,
                productId: data.productId
            };

            if (data.isRopisSku) {
                options.fulfillmentType = 'ROPIS';
            }

            let url = '/api/users/profiles/shoppingList';

            if (shoppingListUtils.isSLSServiceEnabled(isSLSABTestEnabled)) {
                url = '/api/v3/users/profiles/shoppingList';
            }

            return {
                url: url,
                options: {
                    method: 'POST',
                    headers: userXTimestampHeader(),
                    body: JSON.stringify(options)
                }
            };
        })
    );
}

function removeItemsFromShoppingList(params, profileId, productId, isSLSABTestEnabled = false) {
    return _makeMultipleRequests(
        params.map(skuId => {
            const urlBase = shoppingListUtils.isSLSServiceEnabled(isSLSABTestEnabled) ? '/api/v3/users/profiles/' : '/api/users/profiles/';
            let url = urlBase + profileId + '/shoppingList/' + skuId;

            if (productId) {
                url = url + '?productId=' + productId;
            }

            return {
                url,
                options: { method: 'DELETE' }
            };
        })
    );
}

function getShoppingList(profileId, options = {}, isSLSABTestEnabled = false) {
    const id = options.isPublicLovesList ? 'current' : profileId;
    let url = '/api/users/profiles/' + id + '/shoppingList';

    if (shoppingListUtils.isSLSServiceEnabled(isSLSABTestEnabled)) {
        url = '/api/v3/users/profiles/' + id + '/shoppingList';
    }

    const { itemsPerPage, currentPage, sortBy } = options;

    const qsParams = {
        itemsPerPage,
        currentPage,
        sortBy
    };

    if (options.token) {
        qsParams.token = options.token;
    }

    const qs = urlUtils.makeQueryString(qsParams);

    if (qs) {
        url += '?' + qs;
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default {
    addItemsToShoppingList,
    removeItemsFromShoppingList,
    getShoppingList
};
